import { createContext } from 'react';
import { ToastContextType } from 'shared/types/toast';

export const ToastContext = createContext<ToastContextType | undefined>(undefined);
